import { render, staticRenderFns } from "./listTestimonials.vue?vue&type=template&id=03fb71ba&"
import script from "./listTestimonials.vue?vue&type=script&lang=js&"
export * from "./listTestimonials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports